<template>
  <div class="d-flex justify-center align-center">
    <v-card
      class="d-flex flex-column align-center px-2 px-sm-8 pb-2 pb-sm-6 pt-2 pt-sm-6 text-center"
      elevation="4"
    >
      <icon-dragon v-if="showAffiliationLogo" class="dragon-icon mt-n4 mb-n8" />

      <h1 class="text-h6 text-sm-h5 text-md-h4 font-weight-black mb-4">
        <i18n path="message.finished.title">
          <br />
        </i18n>
      </h1>
    </v-card>
  </div>
</template>

<script>
import IconDragon from '@/components/common/IconDragon.vue';

import { HIDE_AFFILIATION } from '@/config/features';

export default {
  components: {
    IconDragon,
  },
  computed: {
    showAffiliationLogo() {
      return !HIDE_AFFILIATION;
    },
  },
};
</script>

<style scoped lang="scss">
.dragon-icon {
  height: 200px;
}
</style>
